import { render } from "./propertiesGrid.vue?vue&type=template&id=4710d136"
import script from "./propertiesGrid.vue?vue&type=script&lang=js"
export * from "./propertiesGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__